module.exports = __webpack_public_path__ + "img/section-3-content_1_t_icon1.1aa6f15e.png";